import React from 'react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Siti Rahayu',
      title: 'Marketing Director, <b>Wall’s Corneto</b>',
      description: 'SocialBread telah membantu kami meningkatkan konversi sebesar 150% dalam 3 bulan. Mereka benar-benar memahami kebutuhan bisnis kami.',
      image: 'https://i.ibb.co.com/tTHnY0Lh/cornetto.png',
    },
    {
      name: 'Andi Wijaya',
      title: 'Founder, <b>Ventela Cimahi</b>',
      description: 'Konten kreatif yang dihasilkan oleh tim SocialBread sangat memukau dan sesuai dengan identitas brand kami. Mereka adalah partner yang luar biasa dalam perjalanan branding kami.',
      image: 'https://i.ibb.co.com/tpvPrD10/Frame-24.png',
    },
    {
      name: 'Budi Prasetyo',
      title: 'CEO, <b>Jasa Media</b>',
      description: 'Strategi digital marketing yang dirancang oleh SocialBread telah membantu kami meningkatkan konversi sebesar 150% dalam 3 bulan. Mereka benar-benar memahami kebutuhan bisnis kami.',
      image: 'https://i.ibb.co.com/pCHs4TW/bukan-main.png',
    },
  ];

  return (
    <section id="testimonials" className="tw-py-16 md:tw-py-24 tw-bg-[#e8e8e8]">
      <div className="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-3xl md:tw-text-5xl tw-font-bold tw-text-dark tw-mb-4 title-gradient">Apa kata mereka?</h2>
          <p className="tw-text-gray-600 tw-max-w-3xl tw-mx-auto">Dengan bangga, kami telah membantu banyak perusahaan untuk meningkatkan visibilitas dan kinerja mereka.</p>
        </div>
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-6 md:tw-gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="tw-bg-white tw-p-8 tw-rounded-lg tw-shadow-md">
              <div className="banner_img tw-mb-5">
                <img src={testimonial.image} alt={testimonial.name} />
              </div>
              <div className="tw-flex tw-items-center tw-mb-4">
                <div className="tw-text-primary"> <svg className="tw-w-5 tw-h-5 tw-fill-current" viewBox="0 0 24 24">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                </svg></div>
                <div className="tw-text-primary"> <svg className="tw-w-5 tw-h-5 tw-fill-current" viewBox="0 0 24 24">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                </svg></div>
                <div className="tw-text-primary"> <svg className="tw-w-5 tw-h-5 tw-fill-current" viewBox="0 0 24 24">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                </svg></div>
                <div className="tw-text-primary"> <svg className="tw-w-5 tw-h-5 tw-fill-current" viewBox="0 0 24 24">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                </svg></div>
                <div className="tw-text-primary"> <svg className="tw-w-5 tw-h-5 tw-fill-current" viewBox="0 0 24 24">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"></path>
                </svg></div>
              </div>
              <p className="tw-text-gray-600 tw-mb-6" dangerouslySetInnerHTML={{ __html: testimonial.description }}></p>
              <div className="tw-flex tw-items-center">
                <div>
                  <h4 className="tw-font-semibold tw-text-dark" dangerouslySetInnerHTML={{ __html: testimonial.name }}></h4>
                  <p className="tw-text-sm tw-text-gray-500" dangerouslySetInnerHTML={{ __html: testimonial.title }}></p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;